<template>
    <b-modal v-if="!loading" id="order_form" ref="order_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            Order
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-alert show variant="info">
                        Requested By <br>
                        Name: Demo User <br>
                        Designation: 8th year student <br>
                        Facility: 5th <br>
                        Branch: 10th <br>
                        Store: 100th <br>
                    </b-alert>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-alert show variant="info">
                        Approved by<br>
                        Name: Demo User <br>
                        Designation: 8th year student <br>
                    </b-alert>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Code" class="has-float-label">
                        <template v-slot:label>
                            <span>Code <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.code" :class="{'border-danger': 'code' in errors}"
                                      @input="'code' in errors ? delete errors.code : ''"
                                      autocomplete="off" placeholder="Facility Code"/>

                        <b-form-invalid-feedback :state="!'code' in errors"
                                                 v-text="'code' in errors ? errors.code[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.date"
                            @input="'date' in errors ? delete errors.date : ''"
                            :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'date' in errors"
                                                 v-text="'date' in errors ? errors.date[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Request Code" class="has-float-label">
                        <template v-slot:label>
                            <span>Request Code <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.request_code" :class="{'border-danger': 'request_code' in errors}"
                                      @input="'request_code' in errors ? delete errors.request_code : ''"
                                      autocomplete="off" placeholder="Request Code"/>

                        <b-form-invalid-feedback :state="!'request_code' in errors"
                                                 v-text="'request_code' in errors ? errors.request_code[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Item" class="has-float-label">
                        <template v-slot:label>
                            <span>Item <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateItem" v-model="selected.item" :options="items"
                                  :border-danger="'item_id' in errors"/>

                        <b-form-invalid-feedback :state="!'item_id' in errors"
                                                 v-text="'item_id' in errors ? errors.item_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Facilities" class="has-float-label">
                        <template v-slot:label>
                            <span>Facilities <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateFacility" v-model="selected.facility" :options="facilities"
                                  :border-danger="'facility_id' in errors"/>

                        <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                 v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Store" class="has-float-label">
                        <template v-slot:label>
                            <span>Store <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateStore" v-model="selected.store" :options="stores"
                                  :border-danger="'store_id' in errors"/>

                        <b-form-invalid-feedback :state="!'store_id' in errors"
                                                 v-text="'store_id' in errors ? errors.store_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Supplier" class="has-float-label">
                        <template v-slot:label>
                            <span>Supplier <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateSupplier" v-model="selected.supplier" :options="suppliers"
                                  :border-danger="'supplier_id' in errors"/>

                        <b-form-invalid-feedback :state="!'supplier_id' in errors"
                                                 v-text="'supplier_id' in errors ? errors.supplier_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row class="mb-4">
                <b-colxx md="12">
                    <vue-dropzone ref="fileDropZone" id="dropzone"
                                  @vdropzone-error="attachmentError"
                                  :destroy-dropzone="false" :options="dropzoneOptions"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Tax" class="has-float-label">
                        <template v-slot:label>
                            <span>Tax <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.tax" :class="{'border-danger': 'tax' in errors}"
                                      @input="'tax' in errors ? delete errors.tax : ''"
                                      autocomplete="off" placeholder="Tax"/>

                        <b-form-invalid-feedback :state="!'tax' in errors"
                                                 v-text="'tax' in errors ? errors.tax[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Discount" class="has-float-label">
                        <template v-slot:label>
                            <span>Discount <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.discount" :class="{'border-danger': 'discount' in errors}"
                                      @input="'discount' in errors ? delete errors.discount : ''"
                                      autocomplete="off" placeholder="Discount"/>

                        <b-form-invalid-feedback :state="!'discount' in errors"
                                                 v-text="'discount' in errors ? errors.discount[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Payment" class="has-float-label">
                        <template v-slot:label>
                            <span>Payment <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updatePayment" v-model="selected.payment" :options="payments"
                                  :border-danger="'payment_id' in errors"/>

                        <b-form-invalid-feedback :state="!'payment_id' in errors"
                                                 v-text="'payment_id' in errors ? errors.payment_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12" class="mb-4">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>
        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('order_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitOrder">Submit</state-button>

            <state-button v-else variant="primary" :click="updateOrder">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment";
import VueDropzone from "vue2-dropzone";
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "OrderformModal",

    components: {
        VueDropzone,
        StateButton,
    },

    props: [
        'edit'
    ],

    data() {
        return{
            loading: true,
            datepicker: {
                date: null,
            },
            selected: {
                facilty: [],
                store: [],
                item: [],
                supplier: [],
                payment: []
            },
            dropzoneOptions: {
                url: 'url',
                thumbnailHeight: 160,
                acceptedFiles: '.jpg,.jpeg,.png,.pdf',
                maxFilesize: 10,
                previewTemplate: this.dropzoneTemplate(),
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.accessToken
                },
                dictDefaultMessage: 'Drop or Click here to upload REFERRAL LETTER.<br>Max file size 10MB.<br>Accepted file types: JPG, JPEG, PNG, PDF.',
                autoProcessQueue: false
            },
        }
    },

    computed: {
        ...mapGetters({
            form: 'getOrderForm',
            errors: 'getOrderErrors',
            facilities: 'getSelectInventoryFacilities',
            stores: 'getSelectStores',
            items: 'getSelectItems',
            suppliers: 'getSelectSuppliers',
            payments: 'getSelectPayments'
        })
    },

    watch: {
        'datepicker.date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
            this.form.date = moment(date).format('YYYY-MM-DD');
        },
    },

    mounted() {
        this.getFormData();
    },

    methods: {
        async getFormData() {
            await this.$store.dispatch('fetchSelectInventoryFacilities');

            return this.loading = false;
        },

        resetForm() {
            this.$store.commit('setOrderForm');

            this.selected = {
                type: [],
                facility: [],
                store: [],
                item: []
            };
        },

        updateFacility(field) {
            if (field) {
                this.form.facility_id = field.facility_id;
            } else {
                this.form.facility_id = '';
            }
            'facility_id' in this.errors ? delete this.errors.facility_id : '';
        },

        updateStore(field) {
            if (field) {
                this.form.store_id = field.store_id;
            } else {
                this.form.store_id = '';
            }
            'store_id' in this.errors ? delete this.errors.store_id : '';
        },

        updateItem(field) {
            if (field) {
                this.form.item_id = field.item_id;
            } else {
                this.form.item_id = '';
            }
            'item_id' in this.errors ? delete this.errors.item_id : '';
        },

        updateSupplier(field) {
            if (field) {
                this.form.supplier_id = field.supplier_id;
            } else {
                this.form.supplier_id = '';
            }
            'supplier_id' in this.errors ? delete this.errors.supplier_id : '';
        },

        updatePayment(field) {
            if (field) {
                this.form.payment_id = field.payment_id;
            } else {
                this.form.payment_id = '';
            }
            'payment_id' in this.errors ? delete this.errors.payment_id : '';
        },

        attachmentError(file, message, xhr) {
            this.$refs.fileDropZone.removeFile(file);
            this.$notify('error filled', 'Error!', file.name + " could not be added!", {
                duration: 6000,
                permanent: false
            });
        },

        dropzoneTemplate() {
            return `<div class="dz-preview dz-file-preview mb-3">
                  <div class="d-flex flex-row "> <div class="p-0 w-30 position-relative">
                      <div class="dz-error-mark"><span><i></i>  </span></div>
                      <div class="dz-success-mark"><span><i></i></span></div>
                      <div class="preview-container">
                        <img data-dz-thumbnail class="img-thumbnail border-0" />
                        <i class="simple-icon-doc preview-icon"></i>
                      </div>
                  </div>
                  <div class="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div> <span data-dz-name /> </div>
                    <div class="text-primary text-extra-small" data-dz-size /> </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                  </div>
                  <a href="#" class="remove" data-dz-remove> <i class="glyph-icon simple-icon-trash"></i> </a>
                </div>`
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        submitOrder() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitOrder', this.form)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new order!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('order_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateOrder() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateOrder', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated order!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('order_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        }
    }
}
</script>

<style scoped>

</style>
